import { ShieldExclamationIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { MarkdownPreview } from '@/components/markdown/MarkdownPreview';
import type {
  WizParsedData,
  WizRenderContext,
} from '@/sections/poe/processors/wiz/types';

export function renderVulnDescription(
  parsed: WizParsedData,
  ctx: WizRenderContext
): void {
  const { vulnerabilityDescription } = parsed;
  const { sections, tempTabs, mainTabKeys } = ctx;

  if (vulnerabilityDescription && mainTabKeys.includes('INFORMATION')) {
    sections['wiz_vulnerability'] = (
      <div className="space-y-4">
        <div className="border-warning border-l-4 p-4">
          <div className="flex items-center">
            <ShieldExclamationIcon className="text-warning mr-2 size-5" />
            <h4 className="text-chariot-text-primary font-semibold">
              Wiz Security Finding
            </h4>
          </div>
        </div>
        <div className="prose max-w-none">
          <div className="border-chariot-stroke bg-chariot-background-primary text-chariot-text-primary rounded border p-4 text-sm leading-relaxed whitespace-pre-wrap">
            <MarkdownPreview source={vulnerabilityDescription} />
          </div>
        </div>
      </div>
    );
    tempTabs['INFORMATION'].push({
      label: 'Vulnerability Details',
      value: 'wiz_vulnerability',
    });
  }
}
